import { BaseUITools } from '@/uiControls/base/baseUITools'
import i18NextClass from '../i18n/index.ts';

export class LangTools extends BaseUITools {
    constructor(id: string) {
        super(id);
        // setupLanguageSwitcher 现在是异步的，但不阻塞构造函数
        new i18NextClass().setupLanguageSwitcher(this, [
            { id: 'en', name: 'English', iconName: 'ChineseOutlined', i18nTitle: 'language.en', label: 'EN' },
            { id: 'zh', name: '中文', iconName: 'EnglishOutlined', i18nTitle: 'language.zh', label: '中' }
        ]).catch(err => {
            console.error('Failed to setup language switcher:', err);
        });
    }
}

export interface LangToolItem {
    id: string;
    name: string;
    iconName: string;
    i18nTitle: string;
    label: string;
}